<template>
  <div class='PrefComp'>
    <div class="label">
      <div class="text-label">{{ label }}</div>
      <div class="arrow">
        <arrow-icon @showSubLinks="newValue => sublink = newValue"/>
      </div>
    </div>
    <div class="cont-select" :class="{ contselect: sublink }">
      <div class="cont-s">
        <select-frente-loja v-if="frenteloja"/>
        <select-cor v-if="lojaCorFundo" label="Cor de fundo" v-model:hexCor="Prefes.lojaCorFundo.corBackground" @update:modelValue="newValue => UpdatePrefComp({ comp: 'lojaCorFundo', prop: 'corBackground', value: newValue })"/>
        <select-cor v-if="lojaCorFonte" label="Cor da fonte" v-model:hexCor="Prefes[comp].color" @update:modelValue="newValue => $emit('update:color', newValue)"/>
        <select-cor v-if="frentelojaCorFundo" label="Cor de fundo" v-model:hexCor="Prefes.frentelojaCorFundo.corBackground" @update:modelValue="newValue => UpdatePrefComp({ comp: 'frentelojaCorFundo', prop: 'corBackground', value: newValue })"/>
        <select-cor v-if="frentelojaCorFonte" label="Cor da fonte" v-model:hexCor="Prefes.frentelojaCorFonte.color" @update:modelValue="newValue => UpdatePrefComp({ comp: 'frentelojaCorFonte', prop: 'color', value: newValue })"/>
        <select-cor v-if="simple" label="Cor de fundo" v-model:hexCor="Prefes[comp].corBackground" @update:modelValue="newValue => $emit('update:corBackground', newValue)"/>
        <select-cor v-if="simple" label="Cor da fonte" v-model:hexCor="Prefes[comp].corFont" @update:modelValue="newValue => $emit('update:corFont', newValue)"/>
        <select-font-comp v-if="simple" :value="Prefes[comp].font" @update:modelValue="newValue => $emit('update:font', newValue)"/>
        <select-cor v-if="spinner" label="Cor" v-model:hexCor="Prefes[comp].cor" @update:modelValue="newValue => $emit('update:corSpinner', newValue)"/>
        <select-spinner v-if="spinner" :spinner="Prefes[comp].tipo" label="Tipo"/>
        <div class="title" v-if="slide">Slide(1300x420px):</div>
        <select-slide v-if="slide"/>
        <div class="title" v-if="slogan">Slogan(1300x200px):</div>
        <select-slogan v-if="slogan"/>
        <div class="title" v-if="category">Categorias(180x200px):</div>
        <select-category v-if="category"/>
        <select-banner v-if="banner"/>
        <select-font-style text="Itálica" :value="parseInt(Prefes[comp].fontStyle)" @update="newValue => $emit('update:fontStyle', newValue ? '1' : '0')" v-if="simple"/>
        <select-font-style text="Negrito" :value="parseInt(Prefes[comp].fontBold)" @update="newValue => $emit('update:fontBold', newValue ? '1' : '0')" v-if="simple"/>
        <select-font-style text="Sublinhado" :value="parseInt(Prefes[comp].textDecoration)" @update="newValue => $emit('update:textDecoration', newValue ? '1' : '0')" v-if="simple"/>
        <input-reg v-if="simple"
        text="Tamanho da fonte(px)"
        :value="Prefes[comp].fontHeight"
        @update:model-value="newValue => $emit('update:fontHeight', newValue)"
        :cont="{ textAlign: 'left' }"
        :label="{ paddingTop: '3px', fontSize: '16px' }"
        :input="{ fontSize: '18px', padding: '1.5%', width: '96%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
        />
        <input-reg 
        v-if="inputWhatsapp"
        text="Número"
        @update:model-value="newValue => wa = newValue"
        :Mask="['(##) #####-####']"
        :value="Empresa.whatsapp"
        :cont="{ textAlign: 'left' }"
        :label="{ paddingTop: '3px', fontSize: '16px' }"
        :input="{ fontSize: '18px', padding: '1.5%', width: '96%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
        />
        <div class="cont-btn-wa" v-if="inputWhatsapp">
          <button @click="updateWhatsapp">Salvar</button>
        </div>
        <select-icon v-if="icone" :icon="Prefes[comp].icon" label="Ícone"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SelectCor from './SelectCor'
import SelectFontComp from './SelectFontComp'
import SelectIcon from './SelectIcon'
import SelectSpinner from './SelectSpinner'
import SelectSlide from './SelectSlide'
import SelectSlogan from './SelectSlogan'
import SelectCategory from './SelectCategory'
import SelectFrenteLoja from './SelectFrenteLoja'
import SelectBanner from './SelectBanner'
import ArrowIcon from '../Icons/ArrowIcon'
import SelectFontStyle from './SelectFontStyle'
import InputReg from '@/components/EnbPainel/Produtos/Register/InputReg'
export default {
  name: 'PrefComp',
  components: { SelectCor, SelectFontComp, SelectIcon, SelectSpinner, SelectSlide, SelectSlogan, SelectCategory, SelectFrenteLoja, SelectBanner, ArrowIcon, SelectFontStyle, InputReg },
  emits: ['update:corBackground', 'update:corFont', 'update:font'],
  data () {
    return {
      sublink: false,
      wa: ''
    }
  },
  props: {
    label: {
      type: String,
      default: 'Label'
    },
    //comp de componente
    comp: {
      type: String,
      default: ''
    },
    icone: {
      type: Boolean,
      default: false
    },
    simple: {
      type: Boolean,
      default: false
    },
    spinner: {
      type: Boolean,
      default: false
    },
    slide: {
      type: Boolean,
      default: false
    },
    slogan: {
      type: Boolean,
      default: false
    },
    category: {
      type: Boolean,
      default: false
    },
    frenteloja: {
      type: Boolean,
      default: false
    },
    frentelojaCorFundo: {
      type: Boolean,
      default: false
    },
    frentelojaCorFonte: {
      type: Boolean,
      default: false
    },
    lojaCorFonte: {
      type: Boolean,
      default: false
    },
    lojaCorFundo: {
      type: Boolean,
      default: false
    },
    banner: {
      type: Boolean,
      default: false
    },
    inputWhatsapp: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['Prefes', 'Empresa']),
    whats () {
      return this.wa.replace('(', '').replace(')', '').replace(' ', '').replace('-', '')
    }
  },
  methods: {
    ...mapActions(['UpdatePrefComp', '_UpdateParamWa']),
    updateWhatsapp () {
      this._UpdateParamWa(this.whats)
    }
  }
}
</script>

<style scoped>
.PrefComp {
  margin-top: 6%;
  border: thin solid #CCCCCC;
  border-radius: 5px;
}

.label {
  display: flex;
  align-items: center;
  text-align: left;
  font-size: 16px;
  color: #648EEA;
  background-color: #EEEEEE;
  border-bottom: thin solid #CCCCCC;
}

.text-label {
  width: 90%;
}

.cont-select {
  max-height: 0px;
  border-radius: 5px;
  overflow: hidden;
  transition: max-height 0.15s ease-out;
}

.contselect {
  border-radius: 5px;
  /* padding: 3%;
  margin-top: 1%; */
  max-height: 600px;
  transition: max-height 0.4s ease-in;
}

.cont-s {
  padding: 3%;
  margin-top: 1%;
}

.text-label {
  padding: 2%;
}

.title {
  text-align: left;
  padding-top: 2%;
}

.cont-btn-wa {
  display: flex;
  justify-content: start;
  padding-top: 2%;
}

button {
  border: 0;
  background-color: #000000;
  color: #FFFFFF;
  padding: 1.5%;
  border-radius: 5px;
  cursor: pointer;
}
</style>
